import Glide from '@glidejs/glide';

export function GlideInitFromId(id, config){
  return new Promise((resolve, reject) => {

    let glideWrapper = document.getElementById(id);

    // build bullets id needed
    let bulletsWrapper = glideWrapper.querySelector('.glide__bullets');
    if(bulletsWrapper) {
      let bulletsCount = glideWrapper.querySelectorAll(`.glide__slide`).length;
      for (let index = 0; index < bulletsCount; index++) {
        let bullet = document.createElement('button');
        bullet.className = 'glide__bullet';
        bullet.setAttribute("data-glide-dir", '='+index);
        bulletsWrapper.appendChild(bullet);
      }
    }

    // init glide and set an after mount resolver
    let glideInstance = new Glide(`#${id}`, config);
    glideInstance.on('mount.after', () => {
      resolve();
    });
    glideInstance.mount();

  });
};

export function GlideGenericHelper(element, config){
    return new Promise((resolve, reject) => {

        let glideWrapper = element;

        // build bullets id needed
        let bulletsWrapper = glideWrapper.querySelectorAll('.glide__bullets');
        bulletsWrapper.forEach(bw => {
            let bulletsCount = glideWrapper.querySelectorAll(`.glide__slide`).length;
            for (let index = 0; index < bulletsCount; index++) {
                let bullet = document.createElement('button');
                bullet.className = 'glide__bullet';
                bullet.setAttribute("data-glide-dir", '='+index);
                bw.appendChild(bullet);
            }
        })

        const nav = element.querySelector(`.tabs__slidenav`);
        // bulletsWrapper.forEach(bw => {
        //   bw.style.marginTop = "-" + nav.offsetHeight + "px";
        // })
        glideWrapper.querySelectorAll(`.glide__slide`).forEach(e => {
          e.style.minHeight = bulletsWrapper.offsetHeight + "px";
        })

        // init glide and set an after mount resolver
        let glideInstance = new Glide(element, config);
        glideInstance.on('mount.after', () => {
            resolve(glideInstance);
        });
        glideInstance.mount();

    });
};


